import { EXTENSOES_AUDIO, EXTENSOES_VIDEO } from '../../utils/chat.constantes';
import { TipoItemGaleria } from '../galeria-midia/models/tipo-item-galeria.model';

export const LIMITES_ARQUIVO_MB: Record<string, number> = {
  jpg: 5, jpeg: 5, png: 5, gif: 5, bmp: 5,
  mp4: 16, mov: 16, avi: 16, mkv: 16,
  mp3: 16, m4a: 16, ogg: 16, amr: 16, webm: 16,
  pdf: 100, doc: 100, docx: 100, xls: 100, xlsx: 100, ppt: 100, pptx: 100,
  webp: 0.1,
};

export const EXT_POR_TIPO: { tipo: string; exts: string[] }[] = [
  { tipo: 'audio', exts: EXTENSOES_AUDIO },
  { tipo: 'image', exts: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'] },
  { tipo: 'video', exts: EXTENSOES_VIDEO },
  { tipo: 'document', exts: ['pdf', 'doc', 'docx'] },
];

export const JANELA_SESSAO_MS = 24 * 60 * 60 * 1000;
export const MAX_PAGINAS_BUSCA_MENSAGEM = 10;
export const TIPO_GALERIA_POR_EXTENSAO: Record<string, TipoItemGaleria> = {
  jpg: 'imagem', jpeg: 'imagem', png: 'imagem', gif: 'imagem', bmp: 'imagem', webp: 'imagem', svg: 'imagem',
  mp4: 'video', mov: 'video',
  pdf: 'embed', txt: 'embed', csv: 'embed',
  doc: 'documento', docx: 'documento', xls: 'documento', xlsx: 'documento', ppt: 'documento', pptx: 'documento',
};
export const INTERVALO_ALBUM_MS = 3 * 60 * 1000;
export const ESPERA_REACAO_MS = 400;
export const TELAS_PRE_CARGA = 4;
export const JANELA_INICIAL = 120;
export const PASSO_JANELA = 40;
export const TOLERANCIA_FIM_PX = 4;
export const LIMITE_ENCOLHER_JANELA = JANELA_INICIAL * 2;
export const CLASSES_DESTAQUE_CONVERSA = ['balao-destacado', 'conversa-item-localizado'];
export const DURACAO_DESTAQUE_CONVERSA_MS = 1600;
